import React, { Component } from 'react';
import { connect } from 'react-redux'
import debounce from 'debounce';

import { language, locale } from '../../services/translator';
import { baseUrl } from '../../services/url';

import { pageLoad, updateDisplayType } from '../../actions/shared';
import { DISPLAY_TYPE_MOBILE, DISPLAY_TYPE_DESKTOP } from '../../reducers/shared';

import HeaderLight from 'ui-kit/src/components/HeaderLight/HeaderLight';
import LayerOrientation from 'ui-kit/src/components/LayerOrientation/LayerOrientation';
import Loader from 'ui-kit/src/components/Loader/Loader';
import MapContainer from 'ui-kit/src/components/MapContainer/MapContainer';
import SearchContainer from 'ui-kit/src/components/SearchContainer/SearchContainer';
import StatefulAnnouncement from '../StatefulAnnouncement/StatefulAnnouncement';
import StatefulDiorMap from '../StatefulDiorMap/StatefulDiorMap';
import StatefulFilterBlock from '../StatefulFilterBlock/StatefulFilterBlock';
import StatefulMobileShopBlock from '../StatefulMobileShopBlock/StatefulMobileShopBlock';
import StatefulPopinAppointment from '../StatefulPopinAppointment/StatefulPopinAppointment';
import StatefulPopinNewsletter from '../StatefulPopinNewsletter/StatefulPopinNewsletter';
import StatefulPopinShare from '../StatefulPopinShare/StatefulPopinShare';
import StatefulResultsBlock from '../StatefulResultsBlock/StatefulResultsBlock';
import StatefulSearchBlock from '../StatefulSearchBlock/StatefulSearchBlock';

class App extends Component {

  lastTouchEnd = (new Date()).getTime();

  handleBack = () => {
    window.history.back();
  };

  componentDidMount() {
    this.resizeCallback = debounce(this.onResize.bind(this), 200);
    window.addEventListener('resize', this.resizeCallback);
    this.loadCallback = debounce(this.onLoad.bind(this), 200);
    window.addEventListener('load', this.loadCallback);
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', language);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    window.removeEventListener('load', this.loadCallback);
  }

  onLoad() {
    this.props.pageLoad();
  }

  onResize() {
    const isDesktop = window.matchMedia('(min-width: 992px)').matches;
    if (isDesktop && this.props.displayType !== DISPLAY_TYPE_DESKTOP) {
      // Desktop.
      this.props.updateDisplayType(DISPLAY_TYPE_DESKTOP);
    } else if (!isDesktop && this.props.displayType !== DISPLAY_TYPE_MOBILE) {
      // Mobile.
      this.props.updateDisplayType(DISPLAY_TYPE_MOBILE);
    }
  }

  render() {
    if (this.props.isNavMobileOpen) {
      document.body.classList.add('no-overflow');
    } else {
      document.body.classList.remove('no-overflow');
    }

    let containerStyles = {};
    let contentStyles = {};
    let mapContainerStyles = {};
    let resultsStyles = {};
    let filterStyles1 = {};
    let filterStyles2 = {};
    let headerStyles = {};
    let searchStyles = {};

    if (this.props.displayType === DISPLAY_TYPE_MOBILE) {
      // Mobile.

      const metanavHeight = 60;
      const headerHeight = 97;
      const shopHeight = 276;

      contentStyles = {position: 'absolute', top: metanavHeight, right: 0, bottom: 0, left: 0};
      mapContainerStyles = {height: `calc(100vh - ${metanavHeight + headerHeight}px)`};
      resultsStyles = {height: `calc(100vh - ${metanavHeight + headerHeight}px)`};
      filterStyles2 = {height: `calc(100vh - ${metanavHeight + headerHeight}px)`};
      headerStyles = {height: metanavHeight};

      if (this.props.isMobileShopOpen) {
        mapContainerStyles = {height: `calc(100vh - ${metanavHeight + headerHeight + shopHeight}px)`};
      }
    } else {
      // Desktop.

      const metanavHeight = 60;

      containerStyles = {top: `${metanavHeight}px`};
      contentStyles = {display: 'flex'};
      headerStyles = {height: metanavHeight};
    }

    const homeUrl = `https://www.dior.com/${locale}`;

    return (
      <div className={`app__locale--${locale}`}>
        <HeaderLight baseUrl={baseUrl} homeUrl={homeUrl} onClick={this.handleBack} style={headerStyles}/>
        {this.props.isMapScriptLoaded && <div style={contentStyles}>
          <SearchContainer
            search={(<StatefulSearchBlock style={searchStyles}/>)}
            filters={(<StatefulFilterBlock styleContainer={filterStyles1} styleFilters={filterStyles2}/>)}
            results={(<StatefulResultsBlock style={resultsStyles} />)}
            style={containerStyles}
          />
          <MapContainer style={mapContainerStyles}>
            <StatefulDiorMap/>
            <StatefulAnnouncement />
          </MapContainer>
          {this.props.displayType === DISPLAY_TYPE_MOBILE && <StatefulMobileShopBlock />}
        </div>}
        <StatefulPopinAppointment />
        <StatefulPopinNewsletter />
        <StatefulPopinShare />
        <LayerOrientation />
        <Loader isVisible={this.props.isLoaderVisible} />
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    displayType: state.shared.displayType,
    integrationMode: state.shared.integrationMode,
    isLoaderVisible: state.shared.isLoaderVisible,
    isMapScriptLoaded: state.pointOfSale.isMapScriptLoaded,
    isMobileShopOpen: state.pointOfSale.isMobileShopOpen,
    isNavMobileOpen: state.nav.isNavMobileOpen
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    pageLoad: pageLoad.bind(null, dispatch),
    updateDisplayType: updateDisplayType.bind(null, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js